export default {"src":"/_next/static/media/blog-background.d003f595.svg","height":393,"width":608,"blurWidth":0,"blurHeight":0};